<template>

	<div class="card-compare">

		<figure class="card">

			<div class="card-img" v-if="randomUserFirst.photo">
				<img :src="applyImgSrc(randomUserFirst.photo)" :alt="randomUserFirst.name">
			</div>

			<div class="card-img" v-else>
				<img src="https://via.placeholder.com/280x400/ccc/38BD23?text=image not found" :alt="randomUserFirst.photo">
			</div>

			<div class="card-status" v-if="cardStatus"> Online</div>

			<figcaption class="card-caption" v-if="randomUserFirst.name || randomUserFirst.age">

				<div class="card-name" v-if="randomUserFirst.name"> {{ randomUserFirst.name }} </div>

				<div class="card-age" v-if="randomUserFirst.age">{{ randomUserFirst.age }} years </div>

			</figcaption>

		</figure>

		<span class="card-compare-txt">or</span>

		<figure class="card">

			<div class="card-img" v-if="randomUserSecond.photo">
				<img :src="applyImgSrc(randomUserSecond.photo)" :alt="randomUserSecond.name">
			</div>

			<div class="card-img" v-else>
				<img src="https://via.placeholder.com/280x400/ccc/38BD23?text=image not found" alt="img">
			</div>

			<div class="card-status" v-if="cardStatus"> Online</div>

			<figcaption class="card-caption" v-if="randomUserSecond.name || randomUserSecond.age">

				<div class="card-name" v-if="randomUserSecond.name"> {{ randomUserSecond.name }} </div>

				<div class="card-age" v-if="randomUserSecond.age">{{ randomUserSecond.age }} years </div>

			</figcaption>

		</figure>

	</div>

</template>

<script>
import src from "../controllers/components/CardCompareCtrl";
export default src;
</script>